import React from 'react';
import { useAppDispatch } from '../../../redux/hooks';
import { showToolTip, hideToolTip, toolTipContentInitial } from '../../features/ToolTip/toolTip.slice';
import { IToolTip } from '../../../interface/interfaces';

interface IToolTipWrapperProps {
    toolTipContent?: IToolTip;
    children: React.ReactNode;
    stretch?: boolean;
}

export const ToolTipWrapper: React.FC<IToolTipWrapperProps> = ({ toolTipContent = toolTipContentInitial, children, stretch = true }) => {
    const dispatch = useAppDispatch();
    return (
        <div style={{ width: `${stretch && '100%'}`}} onMouseEnter={() => dispatch(showToolTip(toolTipContent))} onMouseLeave={() => dispatch(hideToolTip())}>
            {children}
        </div>
    );
};
